import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { navesContadas } from "../../helpers/conteos";
import AlmacenChip from "./AlmacenChip";

/**
 * Ficha breve de un inventario para los modales de confirmación: artículos,
 * preparador y las naves donde ya se ha contado
 */
const ResumenInventario = ({ inventario }) => {
    const naves = navesContadas(inventario);

    return (
        <Box sx={{ p: { xs: 1.5, sm: 2 }, backgroundColor: "#f8f9fa", borderRadius: 2, border: "1px solid #e9ecef" }}>
            <Stack spacing={1}>
                <Typography sx={{ fontSize: { xs: 13, sm: 14 }, color: "#495057" }}>
                    #{inventario.id} · {inventario.lineas?.length ?? 0} artículo(s) · {inventario.preparadorNombre || "Sin asignar"}
                </Typography>
                {naves.length === 0 ? (
                    <Typography sx={{ fontSize: 12, color: "#6c757d" }}>Sin contar en ninguna nave</Typography>
                ) : (
                    <Stack direction="row" spacing={0.75} alignItems="center" flexWrap="wrap" useFlexGap>
                        <Typography sx={{ fontSize: 12, color: "#6c757d" }}>Contado en:</Typography>
                        {naves.map((codigo) => (
                            <AlmacenChip key={codigo} codigo={codigo} estilos={{ height: 22, fontSize: 10 }} />
                        ))}
                    </Stack>
                )}
            </Stack>
        </Box>
    );
};

export default ResumenInventario;
